import { useRef, useState } from "react";
import { bool, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useXlsExporter } from "@tools/EstimateEditor/dialogs/XlsExport/useXlsExporter";
import { PdfExportV2 } from "@tools/EstimateEditor/dialogs/PdfExportV2";
import { ActionButton, MenuButton, PopMenu } from "@components";
import { CircularProgress } from "@material-ui/core";
import { ExportIcon, XlsFileDark } from "@assets";
import { useEstimateEditorSettings } from "@tools";
import { MoreVert } from "@material-ui/icons";
import classnames from "classnames";

export const Exports = observer(({
  // attachCover,
  // simpleExport,
  noXls,
  sharedExport,
  className,
  size="large",
}) => {
  const { t } = useTranslation();
  const { isPresetEditor } = useEstimateEditorSettings();
  
  const [ showList, setShowList ] = useState(false);
  const anchor = useRef(null);
  
  const { isLoading: isXlsExporting, exportProposal: exportToXls } = useXlsExporter();
  // const { isLoading: isPdfExporting, exportProposal: exportToPdf } = usePdfExporter({
  //   attachCover,
  //   simpleExport,
  // });
  
  // const handlePdfExport = async () => {
  //   setShowList(false);
  //   await exportToPdf();
  // };
  
  const handleMenuOpen = () => {
    if(isPresetEditor && sharedExport)
      return;
    setShowList(!showList)
  }
  
  const handleXlsExport = (unstyled=false) => async () => {
    setShowList(false);
    await exportToXls(unstyled);
  }
  
  return (
    <>
      <ActionButton
        square
        ref={anchor}
        size={size}
        icon={
          isXlsExporting ? (
            <CircularProgress color="primary" size={20} />
          ) : (
            sharedExport
              ? <MoreVert />
              : <ExportIcon />
          )
        }
        onClick={handleMenuOpen}
        color="secondary"
        name={t("views.editor.export")}
        className={classnames(sharedExport && "preset-commentsSidebarButton", className)}
        tooltip
      />
      <PopMenu
        show={showList}
        anchor={anchor.current}
        onClickAway={() => setShowList(false)}
        placement="bottom-end"
      >
        {/*<MenuButton*/}
        {/*  className="justify-between"*/}
        {/*  endIcon={<PdfFile />}*/}
        {/*  onClick={handlePdfExport}*/}
        {/*>*/}
        {/*  {t("views.editor.export_name.pdf")}*/}
        {/*</MenuButton>*/}
        <PdfExportV2
          noSettingsDialog={sharedExport}
          onClose={() => setShowList(false)}
        />
        {
          !noXls && !sharedExport &&
          <MenuButton
            className="justify-between"
            endIcon={<XlsFileDark />}
            onClick={handleXlsExport(true)}
          >
            {t("views.editor.export_name.xls.unstyled")}
          </MenuButton>
        }
        {
          !noXls && !sharedExport &&
          <MenuButton
            className="justify-between"
            endIcon={<XlsFileDark className="color-primary" />}
            onClick={handleXlsExport(false)}
          >
            {t("views.editor.export_name.xls.styled")}
          </MenuButton>
        }
        {
          !noXls && sharedExport &&
          <MenuButton
            className="justify-between"
            endIcon={<XlsFileDark className="color-primary" />}
            onClick={handleXlsExport(false)}
          >
            {t("views.editor.export_name.xls.unstyled")}
          </MenuButton>
        }
      </PopMenu>
    </>
  );
})

Exports.propTypes = {
  // attachCover: bool,
  // simpleExport: bool,
  noXls: bool,
  sharedExport: bool,
  size: oneOf(["small", "medium", "large"]),
}